'use client';

import { ReactNode, useEffect, useRef } from 'react';
import { Form } from '@personly/libs-widgets';

interface Props {
  children: ReactNode;
}

const RegisterForm = ({ children }: Props) => {
  const ref = useRef<HTMLFormElement>(null);

  useEffect(() => {
    // copy reference to not lose it on cleanup
    const safe = ref.current;

    const cb = function () {
      if (window.qp) window.qp('track', 'CompleteRegistration');
    };

    safe!.addEventListener('submit', cb);
    return () => safe!.removeEventListener('submit', cb);
  });

  return (
    <Form method="post" action="/agon/v1/guest/createAccount" ref={ref}>
      {children}
    </Form>
  );
};

export default RegisterForm;
